// extracted by mini-css-extract-plugin
export default {"modal_overlay":"Notification_Modal_modal_overlay__kFSAO","modal_contant":"Notification_Modal_modal_contant__2YKUW","close-btn":"Notification_Modal_close-btn__3R-fU"};